import Iconify from 'src/components/iconify';

export const DocFavoriteIcon = ({
  starred,
}: { starred: boolean | undefined }) => {
  return (
    <Iconify
      icon={starred ? 'eva:star-fill' : 'eva:star-outline'}
      color={starred ? 'yellow' : 'primary'}
    />
  );
};
